const CACHE_KEY = "ifen_total_courses";
const CACHE_TS_KEY = "ifen_total_courses_timestamp";
const ONE_HOUR = 1000 * 60 * 60;

function readCache(): { value: number; isValid: boolean } | null {
	if (!import.meta.client) return null;

	const raw = localStorage.getItem(CACHE_KEY);
	if (!raw) return null;

	const value = Number(raw);
	if (!value) return null;

	const timestamp = Number(localStorage.getItem(CACHE_TS_KEY));
	return { value, isValid: !!timestamp && Date.now() - timestamp < ONE_HOUR };
}

function writeCache(count: number) {
	if (!import.meta.client) return;
	localStorage.setItem(CACHE_KEY, String(count));
	localStorage.setItem(CACHE_TS_KEY, String(Date.now()));
}

const totalCourses = ref<number | null>(null);
const isLoading = ref(false);
let loadPromise: Promise<void> | null = null;

export function useTotalCourses() {
	function load(): Promise<void> {
		if (loadPromise) return loadPromise;

		loadPromise = (async () => {
			const cached = readCache();
			if (cached) {
				totalCourses.value = cached.value;
				if (cached.isValid) return;
			}

			try {
				isLoading.value = true;
				const result = await GqlGetTotalCourses();
				const real = result?.courses?.totalCount ?? null;
				if (real && real > 0) {
					totalCourses.value = real;
					writeCache(real);
				}
			}
			catch (e) {
				console.error("[useTotalCourses] Erreur :", e);
				if (cached) totalCourses.value = cached.value;
			}
			finally {
				isLoading.value = false;
			}
		})();

		return loadPromise;
	}

	return {
		totalCourses: readonly(totalCourses),
		isLoading: readonly(isLoading),
		load,
	};
}
